import { ReactElement } from 'react';
import { Controller } from 'react-hook-form';
import { PasswordField as ToqioPassword } from '@toqio/toqio-web-components';
import { isFunction } from 'lodash';

import { ControllerRenderProps } from '../types/form';
import { RenderPasswordProps, PasswordProps } from './password.d';

export const RenderPassword = (props: RenderPasswordProps): ReactElement => {
  const {
    placeholder = '',
    hint = '',
    label = '',
    disabled = false,
    role,
    ariaLabel,
    id, // password field props
    inputRef,
    max,
    min, // input other props
    inputClassName = '',
    boxClassName = '',
    boxStyle = {},
    inputStyle = {}, // style props
    onChange,
    value = '',
    fieldState,
  }: RenderPasswordProps = props;

  return (
    <ToqioPassword
      {...props}
      ref={inputRef}
      label={label}
      hint={hint}
      disabled={disabled}
      onChange={onChange}
      onPaste={onChange}
      value={value}
      error={fieldState?.error?.message}
      placeholder={placeholder}
      min={min}
      max={max}
      className={boxClassName}
      style={boxStyle}
      inputClassName={inputClassName}
      inputStyle={inputStyle}
      role={role}
      ariaLabel={ariaLabel}
      id={id}
    />
  );
};

export const Password = ({ onChange: onChangeField, ...props }: PasswordProps): ReactElement => {
  return (
    <Controller
      name={props.name}
      control={props.control}
      rules={props.rules}
      render={({ field: { onChange, onBlur, value }, fieldState }: ControllerRenderProps): ReactElement => {
        const handleChange = (newValue: string): void => {
          onChange(newValue);
          if (isFunction(onChangeField)) {
            onChangeField(newValue);
          }
        };
        return (
          <RenderPassword
            fieldState={fieldState}
            onChange={handleChange}
            onBlur={onBlur}
            value={value as string}
            {...props}
          />
        );
      }}
    />
  );
};
